import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BarChartComponent } from "./bar-chart/bar-chart.component";
import { LineChartComponent } from "./line-chart/line-chart.component";
import { RadarChartComponent } from "./radar-chart/radar-chart.component";
import { DoughnutComponent } from "./doughnut/doughnut.component";
import { PieChartComponent } from "./pie-chart/pie-chart.component";

@NgModule({
    declarations: [
        BarChartComponent,
        // LineChartComponent,
        RadarChartComponent,
        DoughnutComponent,
        PieChartComponent,
    ],
    exports: [
        BarChartComponent,
        // LineChartComponent,
        RadarChartComponent,
        DoughnutComponent,
        PieChartComponent,
    ],
    imports: [CommonModule],
})
export class ChartsModule {}
